export default {
  componentDidUpdate(prevProps) {
    let wasTracked = prevProps.isTracked,
      isTracked = this.props.isTracked;

    //If the item is now tracked, and the tracked position has changed, update the item detail focus, and scroll to it
    if (isTracked && wasTracked !== isTracked) {
      this._setItemDetailFocus();
      if (this._item) this._scrollToTrackedItem();
    }
  },

  _scrollToTrackedItem() {
    const item = this._item;

    const container = document.getElementsByClassName('csr-cue-list')[0];

    // get how far the container is already scrolled, plus
    // the distance from the top of the viewport the next cue is at
    // then subtract 200 and then some, which is the height of the header
    // do a bit more so the previous cue is slightly visible
    // then, reset the `container.scrollTop` property

    var currentValue;
    var iterationCount = 0; // the current frame
    var start = container.scrollTop;
    var end = start + item.getBoundingClientRect().top - 200;
    var change = end - start;
    var totalIterations = 60 / 2; // ~60 animation frames/sec

    (function scrollWithEase() {
      iterationCount++;

      currentValue = easeInOutQuad(
        iterationCount,
        start,
        change,
        totalIterations,
      );

      container.scrollTop = currentValue;

      if (iterationCount >= totalIterations) return;

      window.requestAnimationFrame(scrollWithEase);
    })();

    function easeInOutQuad(
      currentIteration,
      startValue,
      changeInValue,
      totalIterations,
    ) {
      if ((currentIteration /= totalIterations / 2) < 1) {
        return (
          (changeInValue / 2) * currentIteration * currentIteration + startValue
        );
      }
      return (
        (-changeInValue / 2) *
          (--currentIteration * (currentIteration - 2) - 1) +
        startValue
      );
    }
  },
};
